import { asyncAction } from '@/lib/action';

export const getPayCategoriesAction = asyncAction('PAY_CATEGORIES/GET');
